<template>
  <div class="container-fluid">

    <div v-if="step === 0" class="vertical-align-wrap">
      <div id="opening" class="vertical-align-middle maintenance">
        <div class="text-center">
          <article>
            <h1><span>Quality Observation</span></h1>
            <br/>
            <div>
              <h4><span>Quality is Everyone's Responsibility</span></h4>
              <h5><span>Did you observe anything around you related to quality ? (Apakah anda melakukan observasi terkait kualitas?)</span></h5>
            </div>
          </article>
          <div class="margin-top-30">
            <router-link to="" class="btn btn-info" @click.native="startStep"><i class="icon-control-play"></i> Start</router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="row clearfix">
        <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="card">
                <div class="body">
                    <h6 class="p-10 bg-dark text-light">Quality Observation</h6>
                        <div class="accordion custom" id="accordion">
                            <div>
                                <div class="card-header" id="headingOne">
                                    <h5 class="mb-0">
                                        <button class="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                                        Quality is Everyone's Responsibility
                                        </button>
                                    </h5>
                                </div>                                
                                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                                    <div class="card-body">
                                        Did you observe anything around you related to quality ? (Apakah anda melakukan observasi terkait kualitas?)
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </div>
    </div> -->

    <div v-if="step !== 0" class="row clearfix">
        <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="card">
                <div class="body">
                    <h6 class="p-10 bg-secondary text-light">{{ stepOfQuestion[step].titleOfSection }}</h6>
                        <div class="accordion custom" id="accordion">
                            <div>
                                    
                                <div v-if="stepOfQuestion[step].section === 'begin'" class="card-body">
                                  <div class="form-group">
                                    <p> <b>What department are you from?</b> </p>
                                    <p> Anda dari department apa?</p>
                                    <!-- <app-dropdown :id="'department'" :keyName="'department'" :model="obs.department" :lists="departmentList" :title="'name'" :value="'id'" v-on:selectedChanged="selectChange"></app-dropdown> -->
                                    <select class="form-control show-tick ms select2" data-placeholder="Select" v-model="obs.department">
                                        <option></option>
                                        <option value="Betaine">Betaine</option>
                                        <option value="Bulk Logistics">Bulk Logistics</option>
                                        <option value="CM Cell">CM Cell</option>
                                        <option value="Dove, Soap & Natural Surfactant">Dove, Soap & Natural Surfactant</option>
                                        <option value="Engineering">Engineering</option>
                                        <option value="Fatty Acid 1">Fatty Acid 1</option>
                                        <option value="Fatty Acid 2">Fatty Acid 2</option>
                                        <option value="Finance">Finance</option>
                                        <option value="HR">HR</option>
                                        <option value="Innovation">Innovation</option>
                                        <option value="Logistics">Logistics</option>
                                        <option value="Marvel 2">Marvel 2</option>
                                        <option value="Marvel 3">Marvel 3</option>
                                        <option value="Others">Others</option>
                                        <option value="Planning">Planning</option>
                                        <option value="Procurement">Procurement</option>
                                        <option value="Quality and Technical">Quality and Technical</option>
                                        <option value="Sales">Sales</option>
                                        <option value="SC General">SC General</option>
                                        <option value="SHE">SHE</option>
                                        <option value="Soap 2">Soap 2</option>
                                        
                                    </select>
                                    <input v-if="obs.department === 'Other'" type="text" v-model="obs.departmentOther" class="form-control" placeholder="Please fill the other department" required> 
                                  </div>
                                  <div class="form-group">
                                    <p> <b>please choose employee name and employee number</b></p>
                                    <p>mohon pilih nama dan nomor ID</p>
                                  </div>
                                  <div class="form-group form-row">
                                    <app-lookup-field :model="obs" :element="employeeLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
                                  </div>
                                  <div class="form-group">
                                    <p> <b>Please write your name if your name not in the list.</b></p>
                                    <p>Mohon tulis nama anda jika nama anda tidak termasuk di dalam list.</p>
                                  </div>
                                  <div class="form-group form-row">
                                    <div class="col">
                                      <input type="text" placeholder="Employee Name" class="form-control" v-model="obs.otherEmployeeName">
                                    </div>
                                  </div>
                                  <div class="form-group">
                                    <p> <b>When did you do this observation?</b></p>
                                    <p>Kapan anda melakukan observasi ini?</p>
                                    <flat-pickr class="form-control" v-model="obs.date"></flat-pickr>
                                  </div>
                                  <div class="form-group">
                                    <p> <b>What area did you observe?</b></p>
                                    <p>Area mana kah yang anda observasi?</p>
                                    <!-- <select class="form-control show-tick ms select2" data-placeholder="Select" v-model="obs.areaObserve">
                                      <option></option>
                                      <option value="Production Fatty Acid">Production Fatty Acid</option>
                                      <option value="Production Soap">Production Soap</option>
                                      <option value="Production Dove">Production Dove</option>
                                      <option value="Flaking, Bagging and Drumming">Flaking, Bagging and Drumming</option>
                                      <option value="Warehouse">Warehouse</option>
                                      <option value="TankFarm">TankFarm</option>
                                      <option value="Quality Assurance">Quality Assurance</option>
                                      <option value="Main Office">Main Office</option>
                                      <option value="Gate B">Gate B</option>
                                      <option value="Utility">Utility</option>
                                      <option value="Other">Other</option>
                                    </select> -->
                                    <select type = "dropdown" class="form-control" id="action" v-model="obs.areaObserve" @change="areaSelected()">
                                      <option v-for="(list, index) in this.areaList" :key="index" :value="list.name" >{{ list.name }}</option>
                                    </select>
                                    <input v-if="obs.areaObserve === 'Other'" type="text" v-model="obs.areaObserveOther" class="form-control" placeholder="Please fill the other department" required>
                                  </div>
                                  <div class="form-group">
                                    <p> <b>Who's the PIC? (Area Owner name)</b></p>
                                    <p>Siapa nama PIC nya? (nama Area Owner)</p>
                                  </div>
                                  <div class="form-group form-row">
                                    <app-lookup-field :model="obs" :element="areaOwnerLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
                                  </div>
                                  <!-- <div class="row clearfix">
                                    <div v-for="(image, imageIndex) in imagesOfAreaObserve" :key="`areaobserver-${imageIndex}`" class="col-lg-3 col-md-4 col-sm-12">
                                      <div class="card">
                                        <div class="file">
                                          <a href="javascript:void(0);">
                                            <div class="image">
                                              <img :src="image.path" alt="img" class="img-fluid" @click="chooseAreaObserve(imageIndex)">
                                            </div>
                                            <div class="file-name">
                                              <p v-if="areaObserveSelected === imageIndex" class="m-b-5 text-muted">
                                                <b>{{ image.value }}</b>
                                              </p>
                                              <p v-if="areaObserveSelected !== imageIndex" class="m-b-5 text-muted">
                                                {{ image.value }}
                                              </p>
                                            </div>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div> -->
                                  <!-- <div class="form-group">
                                    <p> <b>Please write down person and department in charge of this Non Conformance. (Ex : Syukron, Quality)</b></p>
                                    <p>Mohon tuliskan nama orang dan departemen yang bertanggungjawab atas ketidak sesuaian ini. (contoh: Syukron, Quality)</p>
                                  </div>
                                  <div class="form-group form-row">
                                    <div class="col">
                                      <input type="text" placeholder="PIC" class="form-control" required v-model="obs.pic">
                                    </div>
                                    <div class="col">
                                      <input type="text" placeholder="DIC" class="form-control" required v-model="obs.dic">
                                    </div>
                                  </div> -->
                                  <div class="form-group">
                                    <p> <b>What quality category did you observe?</b> </p>
                                    <p>Kategori kualitas apakah yang ada observasi?</p>
                                    <select class="form-control show-tick ms select2" data-placeholder="Select" v-model="obs.categoryObserve">
                                        <option></option>
                                        <option value="Product Quality (kualitas produk)">Product Quality (kualitas produk)</option>
                                        <option value="Quantity (kuantitas)">Quantity (kuantitas)</option>
                                        <option value="Packaging (bungkusan)">Packaging (bungkusan)</option>
                                        <option value="Employee (pekerja)">Employee (pekerja)</option>
                                        <option value="Work environment (area bekerja)">Work environment (area bekerja)</option>
                                        <option value="Other">Other</option>
                                    </select>
                                    <input v-if="obs.categoryObserve === 'Other'" type="text" v-model="obs.categoryObserveOther" class="form-control" placeholder="Please fill the other category" required>
                                  </div>
                                </div>

                                <div v-if="stepOfQuestion[step].section === 'relatedquality'" class="card-body">
                                  <div class="form-group">
                                    <p> <b>What did you find related to product quality?</b> </p>
                                    <p>apakah yang anda temukan yang berhubungan dengan kualitas produk?</p>
                                    <select class="form-control show-tick ms select2" data-placeholder="Select" v-model="obs.relatedProduct">
                                        <option></option>
                                        <option value="Malodor (berbau)">Malodor (berbau)</option>
                                        <option value="Abnormal product appearance (tampilan produk yang tidak normal)">Abnormal product appearance (tampilan produk yang tidak normal)</option>
                                        <option value="Lumpy noodle (gumpalan noodle)">Lumpy noodle (gumpalan noodle)</option>
                                        <option value="Foreign Matter (benda asing)">Foreign Matter (benda asing)</option>
                                        <option value="Melting product (produk yang meleleh)">Melting product (produk yang meleleh)</option>
                                        <option value="Black spec">Black spec</option>
                                        <option value="Other">Other</option>
                                    </select>
                                    <input v-if="obs.relatedProduct === 'Other'" type="text" v-model="obs.relatedProductOther" class="form-control" placeholder="Please fill the other related product" required>
                                  </div>
                                </div>
                                <div v-if="stepOfQuestion[step].section === 'foreignmatter'" class="card-body">
                                  <div class="form-group">
                                    <p> <b>What foreign matter did you find?</b> </p>
                                    <p>benda asing apakah yang anda temukan?</p>
                                    <select class="form-control show-tick ms select2" data-placeholder="Select" v-model="obs.foreignMatter">
                                        <option></option>
                                        <option value="Wood (kayu)">Wood (kayu)</option>
                                        <option value="Metal (metal)">Metal (metal)</option>
                                        <option value="Insect (serangga)">Insect (serangga)</option>
                                        <option value="Plastic (plastik)">Plastic (plastik)</option>
                                        <option value="Other">Other</option>
                                    </select>
                                    <input v-if="obs.foreignMatter === 'Other'" type="text" v-model="obs.foreignMatterOther" class="form-control" placeholder="Please fill the other foreign matter" required>
                                  </div>
                                  <div class="form-group">
                                    <p> <b>Where did you find the foreign matter? Was it inside or outside primer packaging? Provide as much detail as you can</b> </p>
                                    <p>dimana anda menemukan benda asing? apakah didalam atau diluar packaging? Mohon berikan detail sebanyak-banyaknya</p>
                                    <textarea class="form-control" v-model="obs.foreignMatterLocation" placeholder="Describe the detail" required></textarea>
                                  </div>
                                </div>

                                <div v-if="stepOfQuestion[step].section === 'relatedquantity'" class="card-body">
                                  <div class="form-group">
                                    <p> <b>What did you find related to product quantity?</b> </p>
                                    <p>apakah yang anda temukan yang berhubungan dengan kuantitas produk?</p>
                                    <select class="form-control show-tick ms select2" data-placeholder="Select" v-model="obs.relatedQuantity">
                                        <option></option>
                                        <option value="Shortage based on weight measurement in weight bridge (kekurangan berat sesuai perhitungan beban di weight bridge)">Shortage based on weight measurement in weight bridge (kekurangan berat sesuai perhitungan beban di weight bridge)</option>
                                        <option value="Number of bag per pallet less than standard (jumlah paperbag lebih sedikit dari standart)">Number of bag per pallet less than standard (jumlah paperbag lebih sedikit dari standart)</option>
                                        <option value="Different batch in one pallet (perbedaan batch dalam 1 pallet)">Different batch in one pallet (perbedaan batch dalam 1 pallet)</option>
                                        <option value="Other">Other</option>
                                    </select>
                                    <input v-if="obs.relatedQuantity === 'Other'" type="text" v-model="obs.relatedQuantityOther" class="form-control" placeholder="Please fill the other related quantity" required>
                                  </div>
                                </div>

                                <div v-if="stepOfQuestion[step].section === 'observepackage'" class="card-body">
                                  <div class="form-group">
                                    <p> <b>What packaging did you observed?</b> </p>
                                    <p>Packaging apa yang anda amati?</p>
                                    <select class="form-control show-tick ms select2" data-placeholder="Select" v-model="obs.packageObserve">
                                        <option></option>
                                        <option value="paper bag">paper bag</option>
                                        <option value="jumbo bag">jumbo bag</option>
                                        <option value="drum">drum</option>
                                        <option value="IBC">IBC</option>
                                        <option value="isotanks">isotanks</option>
                                        <option value="container">container</option>
                                        <option value="Other">Other</option>
                                    </select>
                                    <input v-if="obs.packageObserve === 'Other'" type="text" v-model="obs.packageObserveOther" class="form-control" placeholder="Please fill the other related packaging" required>
                                  </div>
                                </div>

                                <div v-if="stepOfQuestion[step].section === 'relatedemployee'" class="card-body">
                                  <div class="form-group">
                                    <p> <b>What did you find related to employee?</b> </p>
                                    <p>Apa yang anda temukan yang berhubungan dengan pekerja?</p>
                                    <select class="form-control show-tick ms select2" data-placeholder="Select" v-model="obs.relatedEmployee">
                                        <option></option>
                                        <option value="Not following GMP standard (tidak mengikuti standart Good Manufacturing Practice)">Not following GMP standard (tidak mengikuti standart Good Manufacturing Practice)</option>
                                        <option value="Not following SOP (tidak melakukan SOP)">Not following SOP (tidak melakukan SOP)</option>
                                        <option value="Other">Other</option>
                                    </select>
                                    <input v-if="obs.relatedEmployee === 'Other'" type="text" v-model="obs.relatedEmployeeOther" class="form-control" placeholder="Please fill the other related employee" required>
                                  </div>
                                </div>

                                <div v-if="stepOfQuestion[step].section === 'relatedwork'" class="card-body">
                                  <div class="form-group">
                                    <p> <b>What did you find related to work environment?</b> </p>
                                    <p>Apa yang anda temukan yang berhubungan dengan lingkungan kerja?</p>
                                    <select class="form-control show-tick ms select2" data-placeholder="Select" v-model="obs.relatedWork">
                                        <option></option>
                                        <option value="Hole for insect entry (lubang serangga)">Hole for insect entry (lubang serangga)</option>
                                        <option value="Dirty work environment (area bekerja yang tidak bersih)">Dirty work environment (area bekerja yang tidak bersih)</option>
                                        <option value="Leak equipment (alat yang mengalami kebocoran)">Leak equipment (alat yang mengalami kebocoran)</option>
                                        <option value="Luminous lamp not connected with power supply (lampu Luminous mati)">Luminous lamp not connected with power supply (lampu Luminous mati)</option>
                                        <option value="Unproper sampling can (kaleng sampel yang tidak sesuai)">Unproper sampling can (kaleng sampel yang tidak sesuai)</option>
                                        <option value="Product packaging filled with waste (limbah yang dimasukkan ke packaging produk)">Product packaging filled with waste (limbah yang dimasukkan ke packaging produk)</option>
                                        <option value="Damage/unproper position of trigonal box (kotak trigonal yang rusak/tidak pada tempatnya)">Damage/unproper position of trigonal box (kotak trigonal yang rusak/tidak pada tempatnya)</option>
                                        <option value="Puddle at workplace (genangan air pada area bekerja)">Puddle at workplace (genangan air pada area bekerja)</option>
                                        <option value="Open doors (pintu yang terbuka)">Open doors (pintu yang terbuka)</option>
                                        <option value="Rat box not checked periodically (kotak tikus tidak di cek secara periodik)">Rat box not checked periodically (kotak tikus tidak di cek secara periodik)</option>
                                        <option value="Other">Other</option>
                                    </select>
                                    <input v-if="obs.relatedWork === 'Other'" type="text" v-model="obs.relatedWorkOther" class="form-control" placeholder="Please fill the other related work" required>
                                  </div>
                                </div>

                                <div v-if="stepOfQuestion[step].section === 'relatedisotanks'" class="card-body">
                                  <div class="form-group">
                                    <p> <b>What did you find related to isotank packaging?</b> </p>
                                    <p>Apa yang anda temukan yang berhubungan dengan isotank?</p>
                                    <select class="form-control show-tick ms select2" data-placeholder="Select" v-model="obs.relatedIsotank">
                                        <option></option>
                                        <option value="Label issues (masalah label)">Label issues (masalah label)</option>
                                        <option value="L3C issues (masalah Last Three Cargo )">L3C issues (masalah Last Three Cargo )</option>
                                    </select>
                                  </div>
                                </div>

                                <div v-if="stepOfQuestion[step].section === 'relatedibc'" class="card-body">
                                  <div class="form-group">
                                    <p> <b>What did you find related to IBC packaging</b> </p>
                                    <p>Apa yang anda temukan yang berhubungan dengan IBC?</p>
                                    <select class="form-control show-tick ms select2" data-placeholder="Select" v-model="obs.relatedIBC">
                                        <option></option>
                                        <option value="Label issue (masalah label)">Label issue (masalah label)</option>
                                        <option value="Dented (penyok)">Dented (penyok)</option>
                                        <option value="Leak (bocor)">Leak (bocor)</option>
                                        <option value="Scratch (tergores)">Scratch (tergores)</option>
                                    </select>
                                  </div>
                                </div>

                                <div v-if="stepOfQuestion[step].section === 'relatedcontainer'" class="card-body">
                                  <div class="form-group">
                                    <p> <b>What did you find related to container packaging?</b> </p>
                                    <p>Apa yang anda temukan yang berhubungan dengan container?</p>
                                    <select class="form-control show-tick ms select2" data-placeholder="Select" v-model="obs.relatedContainer">
                                        <option></option>
                                        <option value="Label issue (masalah label)">Label issue (masalah label)</option>
                                        <option value="Moldy (berjamur)">Moldy (berjamur)</option>
                                        <option value="Broken (retak/berlubang/berkarat)">Broken (retak/berlubang/berkarat)</option>
                                        <option value="No standard container accesories (aksesoris tidak lengkap)">No standard container accesories (aksesoris tidak lengkap)</option>
                                        <option value="Dirty container (kotor)">Dirty container (kotor)</option>
                                    </select>
                                  </div>
                                </div>

                                <div v-if="stepOfQuestion[step].section === 'relatedjumbobag'" class="card-body">
                                  <div class="form-group">
                                    <p> <b>what did you find related to jumbo bag packaging?</b> </p>
                                    <p>Apa yang anda temukan yang berhubungan dengan jumbo bag?</p>
                                    <select class="form-control show-tick ms select2" data-placeholder="Select" v-model="obs.relatedJumboBag">
                                        <option></option>
                                        <option value="Label issue (masalah label)">Label issue (masalah label)</option>
                                        <option value="Tilted bag (jumbo bag miring)">Tilted bag (jumbo bag miring)</option>
                                        <option value="Tied knot (tali kuping terikat)">Tied knot (tali kuping terikat)</option>
                                        <option value="No cora cloth at warehouse (tidak ada cora cloth)">No cora cloth at warehouse (tidak ada cora cloth)</option>
                                        <option value="Damage (rusak/koyak)">Damage (rusak/koyak)</option>
                                    </select>
                                  </div>
                                </div>

                                <div v-if="stepOfQuestion[step].section === 'relatedpaperbag'" class="card-body">
                                  <div class="form-group">
                                    <p> <b>What did you find related to paper bag packaging?</b> </p>
                                    <p>What did you find related to paper bag packaging?</p>
                                    <select class="form-control show-tick ms select2" data-placeholder="Select" v-model="obs.relatedPaperBag">
                                        <option></option>
                                        <option value="Label issue (masalah label)">Label issue (masalah label)</option>
                                        <option value="Damage (rusak/koyak)">Damage (rusak/koyak)</option>
                                        <option value="Dusty (berdebu)">Dusty (berdebu)</option>
                                        <option value="Poor sewed (tidak terjahit dengan baik)">Poor sewed (tidak terjahit dengan baik)</option>
                                    </select>
                                  </div>
                                </div>

                                <div v-if="stepOfQuestion[step].section === 'relateddrum'" class="card-body">
                                  <div class="form-group">
                                    <p> <b>What did you find related to drum packaging</b> </p>
                                    <p>Apa yang anda temukan yang berhubungan dengan drum?</p>
                                    <select class="form-control show-tick ms select2" data-placeholder="Select" v-model="obs.relatedDrum">
                                        <option></option>
                                        <option value="Label issue (masalah label)">Label issue (masalah label)</option>
                                        <option value="Dent (penyok)">Dent (penyok)</option>
                                        <option value="Scratch (tergores)">Scratch (tergores)</option>
                                        <option value="Rust (berkarat)">Rust (berkarat)</option>
                                        <option value="Leak (bocor)">Leak (bocor)</option>
                                    </select>
                                  </div>
                                </div>

                                <div v-if="stepOfQuestion[step].section === 'relatedlabel'" class="card-body">
                                  <div class="form-group">
                                    <p> <b>What did you find related to label issue?</b> </p>
                                    <p>Apa yang anda temukan yang berhubungan dengan label?</p>
                                    <select class="form-control show-tick ms select2" data-placeholder="Select" v-model="obs.relatedLabel">
                                        <option></option>
                                        <option value="Product without label (porduk tanpa label)">Product without label (porduk tanpa label)</option>
                                        <option value="Unmatched label information (informasi label tidaks sesuai dengan produk)">Unmatched label information (informasi label tidaks sesuai dengan produk)</option>
                                        <option value="Unproper label size (ukuran label tidak sesuai)">Unproper label size (ukuran label tidak sesuai)</option>
                                        <option value="No DG label (tidak ada Dangerous Goods label)">No DG label (tidak ada Dangerous Goods label)</option>
                                    </select>
                                  </div>
                                </div>

                                <div v-if="stepOfQuestion[step].section === 'end'" class="card-body">
                                  <div class="form-group">
                                    <p> <b>Please upload your evidence</b> </p>
                                    <app-uploader :fileUrl="obs.evidence" :fieldName="'evidence'" v-on:finishUpload="finishUpload(...arguments)"></app-uploader>
                                  </div>
                                  <div class="form-group">
                                    <p> <b>Please describe and write down any information regarding the non-conformance (ex: batch number; MFG date; PO number; product name)</b> </p>
                                    <p>Mohon jelaskan dan tuliskan informasi mengenai ketidak sesuaian yang anda temui (contoh : nomor batch, tanggal MFG, nomor PO; nama produk)</p>
                                    <textarea class="form-control" placeholder="Describe the detail" required v-model="obs.remark"></textarea>
                                  </div>
                                  <div class="form-group">
                                    <p> <b>Category Level</b> </p>
                                    <p>Category Level</p>
                                    <select class="form-control" data-placeholder="Select" v-model="obs.categoryLevel">
                                      <option></option>
                                      <option value="Low">Low</option>
                                      <option value="Medium">Medium</option>
                                      <option value="High">High</option>
                                      <option value="Critical">Critical</option>
                                  </select>
                                  </div>
                                  <div class="form-group">
                                    <p> <b>Have you reported this issue to related PIC? (apakah anda sudah melaporkan masalah ini kepada PIC terkait?)</b> </p>
                                    <p>Choose "Yes/No". If yes, write his/her name (pilih "ya/tidak". jika ya, tuliskan nama PIC tersebut</p>
                                  </div>
                                  <div class="form-group">
                                    <label class="fancy-radio">
                                        <input type="radio" name="is-reported" :value="true" v-model="obs.isReported" required data-parsley-errors-container="#error-radio">
                                        <span><i></i>Yes</span>
                                    </label>
                                    <label class="fancy-radio">
                                        <input type="radio" name="is-reported" :value="false" v-model="obs.isReported">
                                        <span><i></i>No</span>
                                    </label>
                                    <p id="error-radio"></p>
                                    <input v-if="obs.isReported" type="text" v-model="obs.issueReportedTo" class="form-control" placeholder="PIC name" required>
                                  </div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <button v-if="stepOfQuestion[step].section !== 'begin'" class="btn btn-primary  m-t-15" @click="moveToPreviousStep">Back</button>
                        <button class="btn btn-primary  m-t-15" @click="moveToNextStep">{{ (stepOfQuestion[step].section === 'end') ? 'Finish' : 'Next' }}</button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Vue from 'vue'
import api from '../services/api'
import { Observation } from '../models/observation'
import { prettifyErrorMessage } from '../utils'
import AppUploader from '../components/AppUploader.vue'
import AppLookupField from '../components/AppLookupField.vue'
// import AppDropdown from '../components/AppDropdown.vue'

export default {
  components: {
    AppUploader, AppLookupField
  },
  data() {
    return {
      obs: {
        ...Observation
      },
      employeeLookup: {
        id: 'employee',
        title: 'List of Employee',
        type: 'form',
        apiUrl: 'employee-list',
        filter: ['fullName'],
        fields: [
          {
            placeholder: 'Choose Employee Name',
            width: 9,
            column: 'employeeName'
          }
        ],
        dtElements: [
          {
            title: 'Employee ID',
            column: 'employeeId'
          },
          {
            title: 'Employee Name',
            column: 'fullName'
          },
        ],
        affectedField: [
          {
            from: 'id',
            to: 'employeeId'
          },
          {
            from: 'fullName',
            to: 'employeeName'
          },
        ]
      },
      areaOwnerLookup: {
        id: 'areaOwner',
        title: 'List of Owner Area',
        byParams: true,
        type: 'form',
        apiUrl: 'area-owner-name',
        params: [
          {
            key: 'assignedTo',
            value: 'assignedTo'
          }
        ],
        filter: ['fullName'],
        fields: [
          {
            placeholder: 'Choose Area Owner Name',
            width: 9,
            column: 'areaOwnerName'
          }
        ],
        dtElements: [
          {
            title: 'Owner Area Name',
            column: 'fullName'
          },
        ],
        affectedField: [
          {
            from: 'id',
            to: 'areaOwnerId'
          },
          {
            from: 'fullName',
            to: 'areaOwnerName'
          },
        ]
      },
      listErr: [],
      areaList: [],
      stepOfQuestion: [
        {
          section: 'begin',
          titleOfSection: 'General Information'
        }
      ],
      step: 0,
      titleOfSection: 'General Information',
      section: 'begin',
      areaObserveSelected: 0,
      imagesOfAreaObserve: [
        {
          value: 'Production Fatty Acid',
          path: 'https://upload-qbo.sgp1.digitaloceanspaces.com/area-observe/FattyAcid.jpeg'
        },
        {
          value: 'Production Soap',
          path: 'https://upload-qbo.sgp1.digitaloceanspaces.com/area-observe/Soap.jpeg'
        },
        {
          value: 'Production Dove',
          path: 'https://upload-qbo.sgp1.digitaloceanspaces.com/area-observe/Dove.jpeg'
        },
        {
          value: 'Flaking, Bagging, and Drumming',
          path: 'https://upload-qbo.sgp1.digitaloceanspaces.com/area-observe/Drum.jpeg'
        },
        {
          value: 'Warehouse',
          path: 'https://upload-qbo.sgp1.digitaloceanspaces.com/area-observe/Warehouse.jpeg'
        },
        {
          value: 'TankFarm',
          path: 'https://upload-qbo.sgp1.digitaloceanspaces.com/area-observe/TankFarm.jpeg'
        },
        {
          value: 'Quality',
          path: 'https://upload-qbo.sgp1.digitaloceanspaces.com/area-observe/Quality.jpeg'
        },
        {
          value: 'Main Office',
          path: 'https://upload-qbo.sgp1.digitaloceanspaces.com/area-observe/MainOffice.jpeg'
        },
        {
          value: 'Gate B',
          path: 'https://upload-qbo.sgp1.digitaloceanspaces.com/area-observe/GateB.jpeg'
        },
        {
          value: 'Other',
          path: 'https://upload-qbo.sgp1.digitaloceanspaces.com/area-observe/Other.jpeg'
        }
      ]
    }
  },
  async created() {
    const areaApi = api('area')
    this.areaList = await areaApi.get()
    console.log(this.areaList)
  },
  methods: {
    areaSelected() {
      this.obs.assignedTo = this.areaList.filter(x => x.name === this.obs.areaObserve)[0].id;
    },
    async moveToNextStep() {
      const currentSection = this.stepOfQuestion[this.step].section

      this.validate(currentSection)

      if(this.listErr.length > 0) {
        this.showValidationError()
        return
      }

      // if at the end of step
      if(currentSection === 'end') {
        const questionApi = api('question-list')
        await questionApi.create(this.obs)
        this.$router.push({ name: 'observeSubmitted' })
      }

      // if move from begin
      if(currentSection === 'begin') {
        if(this.obs.categoryObserve === 'Product Quality (kualitas produk)') {
          this.stepOfQuestion.push({
            section: 'relatedquality',
            titleOfSection: 'Related Product Quality'
          })
        } else if(this.obs.categoryObserve === 'Quantity (kuantitas)') {
          this.stepOfQuestion.push({
            section: 'relatedquantity',
            titleOfSection: 'Related Product Quantity'
          })
        } else if(this.obs.categoryObserve === 'Packaging (bungkusan)') {
          this.stepOfQuestion.push({
            section: 'observepackage',
            titleOfSection: 'Package Observation'
          })
        } else if(this.obs.categoryObserve === 'Employee (pekerja)') {
          this.stepOfQuestion.push({
            section: 'relatedemployee',
            titleOfSection: 'Related Employee'
          })
        } else if(this.obs.categoryObserve === 'Work environment (area bekerja)') {
          this.stepOfQuestion.push({
            section: 'relatedwork',
            titleOfSection: 'Related Work'
          })
        } else {
          this.moveToEndOfStep()
        }
      }
      
      if(currentSection === 'relatedquality') {
        if(this.obs.relatedProduct === 'Foreign Matter (benda asing)') {
          this.stepOfQuestion.push({
            section: 'foreignmatter',
            titleOfSection: 'Foreign Matter'
          })
        } else {
          this.moveToEndOfStep()
        }
      }

      if(currentSection === 'foreignmatter' || currentSection === 'relatedlabel' ||
        currentSection === 'relatedquantity' || currentSection === 'relatedemployee'  || 
        currentSection === 'relatedwork') {
        this.moveToEndOfStep()
      }
      
      if(currentSection === 'observepackage') {
        if(this.obs.packageObserve === 'paper bag') {
          this.stepOfQuestion.push({
            section: 'relatedpaperbag',
            titleOfSection: 'Related Paper Bag'
          })
        } else if(this.obs.packageObserve === 'jumbo bag') {
          this.stepOfQuestion.push({
            section: 'relatedjumbobag',
            titleOfSection: 'Related Jumbo Bag'
          })
        } else if(this.obs.packageObserve === 'IBC') {
          this.stepOfQuestion.push({
            section: 'relatedibc',
            titleOfSection: 'Related IBC'
          })
        } else if(this.obs.packageObserve === 'drum') {
          this.stepOfQuestion.push({
            section: 'relateddrum',
            titleOfSection: 'Related Drum'
          })
        } else if(this.obs.packageObserve === 'isotanks') {
          this.stepOfQuestion.push({
            section: 'relatedisotanks',
            titleOfSection: 'Related Isotanks'
          })
        } else if(this.obs.packageObserve === 'container') {
          this.stepOfQuestion.push({
            section: 'relatedcontainer',
            titleOfSection: 'Related Container'
          })
        } else {
          this.moveToEndOfStep()
        }
      }
      
      if(currentSection === 'relatedpaperbag' || currentSection === 'relatedjumbobag' 
         || currentSection === 'relatedibc'  || currentSection === 'relateddrum' 
          || currentSection === 'relatedisotanks'  || currentSection === 'relatedcontainer') {
        
        const labelIssue = 'Label issue (masalah label)'

        if(this.obs.relatedPaperBag === labelIssue || this.obs.relatedJumboBag === labelIssue 
          || this.obs.relatedIBC === labelIssue || this.obs.relatedDrum === labelIssue 
          || this.obs.relatedIsotank === labelIssue || this.obs.relatedContainer === labelIssue) {
          this.stepOfQuestion.push({
            section: 'relatedlabel',
            titleOfSection: 'Related Label'
          })
        } else {
          this.moveToEndOfStep()
        }
      }

      if(this.stepOfQuestion[this.step].section !== 'end') {
        this.step += 1
      }
    },
    startStep() {
      this.stepOfQuestion.push({
        section: 'begin',
        titleOfSection: 'General Information'
      })
      this.step += 1
    },
    moveToPreviousStep() {
      this.step -= 1
      this.stepOfQuestion.splice(this.stepOfQuestion.length - 1, 1)
    },
    chooseAreaObserve(index) {
      this.areaObserveSelected = index
      this.obs.areaObserve = this.imagesOfAreaObserve[index].value
    },
    validate(section) {
      this.listErr = []
      if(section === 'begin') {

        if(this.obs.date === '') this.listErr.splice(this.listErr.length, 0, 'Date must be filled')

        if(this.obs.department === '') this.listErr.splice(this.listErr.length, 0, 'Department must be filled')

        if(this.obs.department === 'Other' && this.obs.departmentOther === '') this.listErr.splice(this.listErr.length, 0, 'Other Department must be filled') 

        if(this.obs.employeeId === '' && this.obs.otherEmployeeName === '') this.listErr.splice(this.listErr.length, 0, 'Employee must be filled')

        // if(this.obs.employeeId === '') this.listErr.splice(this.listErr.length, 0, 'Employee must be filled')

        if(this.obs.areaObserve === '') this.listErr.splice(this.listErr.length, 0, 'Area Observe must be filled')

        if(this.obs.areaObserve === 'Other' && this.obs.areaObserveOther === '') this.listErr.splice(this.listErr.length, 0, 'Other Area Observe must be filled')

        // if(this.obs.pic === '' || this.obs.dic === '') this.listErr.splice(this.listErr.length, 0, 'PIC and DIC must be filled')

        if(this.obs.categoryObserve === '') this.listErr.splice(this.listErr.length, 0, 'Category Observe must be filled')

        if(this.obs.categoryObserve === 'Other' && this.obs.categoryObserveOther === '') this.listErr.splice(this.listErr.length, 0, 'Other category observe must be filled') 

        if(this.obs.areaOwnerId === '') this.listErr.splice(this.listErr.length, 0, 'Area Owner must be filled')
      }

      if(section === 'relatedquality') {
        if(this.obs.relatedProduct === '') this.listErr.splice(this.listErr.length, 0, 'Related Product must be filled')

        if(this.obs.relatedProduct === 'Other' && this.obs.relatedProductOther === '') this.listErr.splice(this.listErr.length, 0, 'Other related product must be filled') 
      }

      if(section === 'foreignmatter') {
        if(this.obs.foreignMatter === '') this.listErr.splice(this.listErr.length, 0, 'Foreign matter must be filled')

        if(this.obs.foreignMatter === 'Other' && this.obs.foreignMatterOther === '') this.listErr.splice(this.listErr.length, 0, 'Other foreign matter must be filled') 

        if(this.obs.foreignMatterLocation === '') this.listErr.splice(this.listErr.length, 0, 'Foreign matter location must be filled')
      }

      if(section === 'relatedquantity') {
        if(this.obs.relatedQuantity === '') this.listErr.splice(this.listErr.length, 0, 'Related Quantity must be filled')

        if(this.obs.relatedQuantity === 'Other' && this.obs.relatedQuantityOther === '') this.listErr.splice(this.listErr.length, 0, 'Other related quantity must be filled') 
      }

      if(section === 'observepackage') {
        if(this.obs.packageObserve === '') this.listErr.splice(this.listErr.length, 0, 'Package Observe must be filled')

        if(this.obs.packageObserve === 'Other' && this.obs.packageObserveOther === '') this.listErr.splice(this.listErr.length, 0, 'Other related package must be filled') 
      }

      if(section === 'relatedpaperbag') {
        if(this.obs.relatedPaperBag === '') this.listErr.splice(this.listErr.length, 0, 'Paper bag must be filled')
      }

      if(section === 'relatedjumbobag') {
        if(this.obs.relatedJumboBag === '') this.listErr.splice(this.listErr.length, 0, 'Jumbo bag must be filled')
      }

      if(section === 'relatedibc') {
        if(this.obs.relatedIBC === '') this.listErr.splice(this.listErr.length, 0, 'IBC must be filled')
      }

      if(section === 'relateddrum') {
        if(this.obs.relatedDrum === '') this.listErr.splice(this.listErr.length, 0, 'Drum must be filled')
      }

      if(section === 'relatedcontainer') {
        if(this.obs.relatedContainer === '') this.listErr.splice(this.listErr.length, 0, 'Container must be filled')
      }

      if(section === 'relatedisotanks') {
        if(this.obs.relatedIsotank === '') this.listErr.splice(this.listErr.length, 0, 'Isotank must be filled')
      }

      if(section === 'relatedlabel') {
        if(this.obs.relatedLabel === '') this.listErr.splice(this.listErr.length, 0, 'Label must be filled')
      }

      if(section === 'relatedemployee') {
        if(this.obs.relatedEmployee === '') this.listErr.splice(this.listErr.length, 0, 'Related employee must be filled')

        if(this.obs.relatedEmployee === 'Other' && this.obs.relatedEmployeeOther === '') this.listErr.splice(this.listErr.length, 0, 'Other related employee must be filled')
      }

      if(section === 'relatedwork') {
        if(this.obs.relatedWork === '') this.listErr.splice(this.listErr.length, 0, 'Related work must be filled')

        if(this.obs.relatedWork === 'Other' && this.obs.relatedWorkOther === '') this.listErr.splice(this.listErr.length, 0, 'Other related work must be filled')
      }

      if(section === 'end') {
        // if(this.obs.evidence === '') this.listErr.splice(this.listErr.length, 0, 'Evidence must be uploaded')
        if(this.obs.categoryLevel === '') this.listErr.splice(this.listErr.length, 0, 'Category Level must be filled')
      }
    },
    showValidationError() {
      Vue.notify({
        group: 'appNotif',
        title: 'Validation errors',
        text: prettifyErrorMessage(this.listErr),
        type: 'error'
      })
    },
    finishUpload(data) {
      const currentData = this.obs
      this.obs = {
        ...currentData,
        ...data
      }
    },
    moveToEndOfStep() {
      this.stepOfQuestion.push({
        section: 'end',
        titleOfSection: 'Final Step'
      })
    },
    // selectChange(data) {
    //   const currentData = this.obs
    //   this.obs = {
    //     ...currentData,
    //     ...data
    //   }
    // }
    finishLookup(data) {
      const currentObs = this.obs
      this.obs = {
          ...currentObs,
          ...data
      }
    }
  }
}
</script>